import { Navigate } from '@tanstack/react-router';

import { useUser } from '@/entities/auth/hooks';
import { isInternalUser } from '@/entities/auth/utils/is-internal-user';

interface Props {
  children: React.ReactNode;
  pendingFallback?: React.ReactNode;
}

export function InternalUserRequired({ children, pendingFallback = null }: Props) {
  const { user, isLoading } = useUser();

  if (isLoading || user == null) {
    return pendingFallback;
  }

  if (!user) {
    return <Navigate to="/login" />;
  }

  if (!isInternalUser(user.email)) {
    return <Navigate to="/" />;
  }

  return children;
}
